import { render } from "./FeedbackDialog.vue?vue&type=template&id=0a68ef79&scoped=true"
import script from "./FeedbackDialog.vue?vue&type=script&lang=js"
export * from "./FeedbackDialog.vue?vue&type=script&lang=js"

import "./FeedbackDialog.vue?vue&type=style&index=0&id=0a68ef79&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-0a68ef79"

export default script